import { Config } from '@/config';
import apiService from '@/services/api.service';

import { ProjectModuleNewsItemConfigDto } from '@/store/module.interface';
import { constant } from '@/constant';

class NewsItemsService {
  async getModuleNewsItems(moduleId: number): Promise<ProjectModuleNewsItemConfigDto[]> {
    const response = await apiService.get<ProjectModuleNewsItemConfigDto[]>(
      `${Config.api.backend.urlV2}/project-modules/${moduleId}/news-items`,
      {
        status: constant.ProjectModule.NewsItem.Status.published,
      },
    );
    return response.data;
  }
}

export const newsItemsService = new NewsItemsService();
